import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
import { SlotGameType1_2 } from "../SlotGameType1_2";

export class FireFruits2 extends SlotGameType1_2
{
	protected override seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide();
}